import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Typography, Button, Paper, CircularProgress, Alert,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Card, CardContent, CardHeader, Divider, Box, Chip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { obterCurso, excluirCurso } from '../../services/cursoService';

const DetalhesCursoPage = () => {
  const [curso, setCurso] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCurso = async () => {
      try {
        const data = await obterCurso(id);
        setCurso(data);
      } catch (error) {
        console.error('Erro ao buscar detalhes do curso:', error);
        setErro('Erro ao buscar detalhes do curso.');
      } finally {
        setLoading(false);
      }
    };

    fetchCurso();
  }, [id]);

  const handleExcluir = async () => {
    if (window.confirm('Tem certeza que deseja excluir este curso?')) {
      try {
        await excluirCurso(id);
        navigate('/cursos');
      } catch (error) {
        console.error('Erro ao excluir curso:', error);
        setErro('Erro ao excluir curso.');
      }
    }
  };

  if (loading) return <CircularProgress />;
  if (erro) return <Alert severity="error">{erro}</Alert>;
  if (!curso) return <Typography>Curso não encontrado.</Typography>;

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
      <Card elevation={3}>
        <CardHeader
          title={curso.nome}
          subheader={`Curso de ${curso.campanha?.nome || 'N/A'}`}
          action={
            <Box>
              <Button
                startIcon={<EditIcon />}
                onClick={() => navigate(`/cursos/editar/${id}`)}
                sx={{ mr: 1 }}
              >
                Editar
              </Button>
              <Button
                startIcon={<DeleteIcon />}
                color="error"
                onClick={handleExcluir}
              >
                Excluir
              </Button>
            </Box>
          }
        />
        <Divider />
        <CardContent>
          <Typography variant="h6" gutterBottom>Informações do Curso</Typography>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">Descrição da Campanha</TableCell>
                  <TableCell>{curso.campanha?.descricao || 'N/A'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Nome da Instituição</TableCell>
                  <TableCell>{curso.campanha?.instituicao?.nome || 'N/A'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Endereço da Instituição</TableCell>
                  <TableCell>{curso.campanha?.instituicao?.endereco || 'N/A'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Contato da Instituição</TableCell>
                  <TableCell>{curso.campanha?.instituicao?.contato || 'N/A'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>Disciplinas</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {curso.disciplinas && curso.disciplinas.length > 0 ? (
              curso.disciplinas.map((disciplina) => (
                <Chip key={disciplina.id} label={disciplina.nome} variant="outlined" />
              ))
            ) : (
              <Typography color="text.secondary">Nenhuma disciplina cadastrada.</Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DetalhesCursoPage;